import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

export const GetVariantQuery = gql`
  query($ean: String, $id: String, $country: String, $currencyId: String) {
    variant(where: { id: $id, ean: $ean, currencyId: $currencyId }, country: $country) {
      id
      ean
      sku
      definition
      inStock
      price
      recommendedPrice
      prices
      product {
        id
        title
        name
        description
        metaTitle
        metaDescription
        sku
        categories {
          id
          name
          slug
          parentCategoryId
        }
        subtitle
        technicalSpecification
        perex
        display
        status
        slug
        tags
        supplier {
          id
          name
        }
        manufacturer {
          id
          name
          description
          manufacturerImage {
            id
            file
          }
        }
        weight
        weightForShipping
        display
        price
        prices
        recommendedPrice
        deliveryPriceAddition
        VATrate
        images {
          id
          values {
            id
          }
          file
          priority
          createdAt
        }
        variants {
          id
          ean
          sku
          definition
          inStock
        }
        availability {
          id
          name
          title
          color
          watchDogAction
          schemaOrg
        }
        files {
          id
          file
          title
        }
        videos {
          id
          url
          title
          priority
        }
        hideForCountry
        neverApplyCustomerDiscounts
        customerGroupsOnlyDiscountIds
        visibleForCustomerGroup
        recommendedProductVariants {
          id
          order
          productVariant {
            id
            ean
            sku
            definition
            price
            recommendedPrice
            prices
            inStock
            product {
              id
              name
              slug
              price
              prices
              recommendedPrice
              tags
              description
              sku
              display
              status
              weight
              weightForShipping
              visibleForCustomerGroup
              images {
                id
                file
                priority
              }
            }
          }
        }
        externalBlogTags
        externalBlogArticleNumber
        purchaseLimitPerPurchase
      }
    }
  }
`;

const CreateLastVisited = gql`
  mutation createLastVisited($lastVisited: CreateLastVisitedInput) {
    createLastVisited(lastVisited: $lastVisited) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
  ean: string;
  country?: string;
  currencyId?: string;
}

interface IResponse {
  data: any;
}

class VariantQuery extends React.Component<ChildProps<IInputProps, IResponse>, {}> {
  public render() {
    const { fullVariant, createLastVisited }: any = this.props;
    return this.props.children({
      fullVariant, createLastVisited
    });
  }
}

export default compose(
  graphql<IInputProps, IResponse>(GetVariantQuery, {
    name: 'fullVariant',
    options: props => ({
      fetchPolicy: (window && window.location ? 'cache-first' : 'network-only'),
      variables: {
        ean: props.ean,
        currencyId: props.currencyId,
        country: props.country,
      }
    })
  }),
  graphql<IInputProps, IResponse>(CreateLastVisited, {
    name: 'createLastVisited',
  })
)(VariantQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Products/FullVariantById.tsx